import { email, normalName, required } from '@/validation'

export const createUserValidationRules = {
  email: { required, email },
  firstname: { required, normalName },
  lastname: { required, normalName },
}
export const updateUserValidationRules = createUserValidationRules
